import { getPublicClientsApi, postPublicDocumentsApi, postPublicClientsApi, putPublicClientsApi, getPublicDocumentsApi } from "@Shared/@Utils/ajax";
import { removeEmptyKeys } from "@Shared/@Utils/utils";
export const getGuestFillOutApplication = async token => {
  const endpoint = "/clients/application/guest-fill-out/application-data";
  return getPublicClientsApi({}, token, endpoint);
};
export const getGuestFillOutSchema = async (token, subdomain = "") => {
  subdomain = subdomain || location.pathname.replace("/", "");
  return getPublicClientsApi({
    newApplication: true
  }, token, `/clients/application/guest-fill-out/application-form?subdomain=${subdomain}`);
};
export const updatePin = async (token, oldCode, code) => {
  const endpoint = "/guest-upload/update-code";
  return postPublicDocumentsApi({
    oldCode,
    code
  }, token, endpoint);
};
export const verifyPin = async (token, code) => {
  const endpoint = "/guest-upload/verify-code";
  return postPublicDocumentsApi({
    code
  }, token, endpoint);
};
export const submitFillOutApplication = async token => {
  const subdomain = location.pathname.replace("/", "");
  const endpoint = `/clients/application/guest-fill-out/submit?subdomain=${subdomain}`;
  return postPublicClientsApi({}, token, endpoint);
};
export const updateFillOutApplication = async (token, rawApplication, changes) => {
  const application = removeEmptyKeys(rawApplication);
  return putPublicClientsApi({
    application,
    changes
  }, token, "/clients/application/guest-fill-out/update");
};
export const getFillOutDisclaimers = async token => {
  const subdomain = location.pathname.replace("/", "");
  return getPublicClientsApi({}, token, `/clients/application/guest-fill-out/disclaimer?subdomain=${subdomain}`);
};
export const getFillOutApplicationValidations = async token => {
  return postPublicClientsApi({}, token, `/clients/application/guest-fill-out/validate`);
};
export const updateFillOutLocalePreference = async (token, localeLanguage) => {
  const endpoint = "/guest-upload/update-locale";
  return postPublicDocumentsApi({
    localeLanguage
  }, token, endpoint);
};
export const getFillOutLocalePreference = async token => {
  const endpoint = "/guest-upload/get-locale";
  return getPublicDocumentsApi({}, token, endpoint);
};